import localStorageAvailable from '../../utils/localStorageAvailable';
import axios from '../../utils/axios';

const getMetaAccount = async (user, grp_id) => {
    const storageAvailable = localStorageAvailable();
    const accessToken = storageAvailable ? localStorage.getItem('accessToken') : '';

    const config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: `/service/campaign_service/v1/campaign/template/meta/accounts`,
        headers: {
            authorization: `Bearer ${accessToken}`,
            user,
        },
        params: { grp_id }
    };
    const response = await axios.request(config);
    return response.data;
};

export default getMetaAccount;
